import { DASHBOARD_MENU_KEY, HISTORY_MENU_KEY } from "./menu.keys";
import type { TFunction } from "i18next";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
export const getSidebarMenuConfig = (t: TFunction) => {
	return [
		{
			key: DASHBOARD_MENU_KEY,
			label: t("layout.sidebar.menuName.dashboard"),
			icon: <WidgetsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
		},

		{
			key: HISTORY_MENU_KEY,
			label: t("layout.sidebar.menuName.history"),
			icon: <HistoryRoundedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.HISTORY,
		},
	];
};
